<template>
  <multi-select-filter
    :id="filterData.key + '-filter'"
    :label="filterData.label"
    :get-value="getOptions"
    :multiple="false"
    :current-set-value="selectionOption"
    :update-method="updateValue"
    track-by="key"
    display-value="title"
  />
</template>

<script>
import MultiSelectFilter from "../MultiSelectFilter.vue";

export default {
  name: "HasReferenceFilter",
  data() {
    return {
      selectionOption: {},
    };
  },
  props: {
    filterData: {
      type: Object,
      required: true,
    },
  },
  components: {
    MultiSelectFilter,
  },
  computed: {
    getOptions: function () {
      return [
        { key: "", title: "- Any -" },
        { key: 1, title: "Yes" },
        { key: 0, title: "No" },
      ];
    },
  },
  methods: {
    updateValue: function (value) {
      this.selectionOption = value;
      if (value !== null && value.hasOwnProperty("key")) {
        switch (value.key) {
          case 0:
            this.$emit("update-filters", this.filterData.key, null, "IS NULL");
            break;

          case 1:
            this.$emit(
              "update-filters",
              this.filterData.key,
              null,
              "IS NOT NULL",
            );
            break;

          default:
            // Clear the filter.
            this.$emit("update-filters", this.filterData.key, null, null);
        }
        this.$emit("update-filter", { id: this.filterData.key, value });
      }
    },
  },
};
</script>
